import styled from 'styled-components'

export const ErrorMessageStyles = styled.p`
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #CC1717;
    margin-top: 5px;
`